<h2 mat-dialog-title class="dialog-header">
  <span>{{ data.febLabel }}</span>
  <span class="badge-statut" [ngClass]="statClass">{{ statLabel }}</span>
</h2>

<mat-dialog-content class="view-content">

  <!-- ───────── SECTION 1 : ACTEURS & INFORMATIONS GÉNÉRALES ───────── -->
  <div class="section-title">
    <mat-icon>people</mat-icon>
    Acteurs & Informations générales
  </div>

  <div class="info-grid">

    <div class="info-item">
      <span class="label">Label de la FEB</span>
      <span class="value">{{ data.febLabel || '—' }}</span>
    </div>

    <div class="info-item">
      <span class="label">Pilote de lot</span>
      <span class="value">{{ data.febPilotLotNom || '—' }}</span>
    </div>

    <div class="info-item">
      <span class="label">Demandeur</span>
      <span class="value">{{ data.febDemandeurNom || '—' }}</span>
    </div>

    <div class="info-item">
      <span class="label">Entité SNCF</span>
      <span class="value">{{ data.febEntiteSncfNom || '—' }}</span>
    </div>

    <div class="info-item">
      <span class="label">Division du demandeur</span>
      <span class="value">{{ data.febDivisionDemandeurNom || '—' }}</span>
    </div>

    <div class="info-item">
      <span class="label">Projet</span>
      <span class="value">{{ data.febProjectNom || '—' }}</span>
    </div>

    <div class="info-item">
      <span class="label">Date de la demande</span>
      <span class="value">{{ data.febDateDemande ? (data.febDateDemande | date:'dd/MM/yyyy') : '—' }}</span>
    </div>

    <div class="info-item">
      <span class="label">Date de démarrage</span>
      <span class="value">{{ data.febDateDemarrage ? (data.febDateDemarrage | date:'dd/MM/yyyy') : '—' }}</span>
    </div>

    <div class="info-item">
      <span class="label">Date fin prévisionnelle</span>
      <span class="value">{{ data.febDateFinPrevisionnelle ? (data.febDateFinPrevisionnelle | date:'dd/MM/yyyy') : '—' }}</span>
    </div>

    <div class="info-item">
      <span class="label">Durée d'intervention</span>
      <span class="value">{{ data.febDuree != null ? data.febDuree + ' j' : '—' }}</span>
    </div>

    <div class="info-item">
      <span class="label">Localisation de mission</span>
      <span class="value">{{ data.febLocalisationLabel || '—' }}</span>
    </div>

    <div class="info-item">
      <span class="label">PC SNCF fourni</span>
      <span class="value">
        <mat-icon [class.icon-oui]="data.febPcSncf" [class.icon-non]="!data.febPcSncf">
          {{ data.febPcSncf ? 'check_circle' : 'cancel' }}
        </mat-icon>
        {{ data.febPcSncf ? 'Oui' : 'Non' }}
      </span>
    </div>

  </div>

  <!-- ───────── SECTION 2 : NOMENCLATURE & DESCRIPTION ───────── -->
  <div class="section-title">
    <mat-icon>description</mat-icon>
    Nomenclature & Description
  </div>

  <div class="info-grid">

    <div class="info-item span-2">
      <span class="label">Activité UO / Nomenclature</span>
      <span class="value">
        {{ data.febUoActivitePressentiLabel || '—' }}
        <ng-container *ngIf="data.febUoNomenclatureLabel">
          — {{ data.febUoNomenclatureLabel }}
        </ng-container>
      </span>
    </div>

    <div class="info-item span-2">
      <span class="label">Nomenclature</span>
      <span class="value">{{ data.febNomenclature || '—' }}</span>
    </div>

    <div class="info-item">
      <span class="label">Présence site SNCF / Télétravail</span>
      <span class="value">{{ data.febPresenceSiteSncf || '—' }}</span>
    </div>

    <div class="info-item">
      <span class="label">Provision déplacement & astreinte</span>
      <span class="value">
        {{ data.febProvisionDeplacementAstreinte != null
           ? (data.febProvisionDeplacementAstreinte | number:'1.2-2') + ' €'
           : '—' }}
      </span>
    </div>

  </div>

  <div class="text-block" *ngIf="data.febContexteObjectifProjet">
    <div class="text-label">Contexte et objectif du projet</div>
    <p class="text-value">{{ data.febContexteObjectifProjet }}</p>
  </div>

  <div class="text-block" *ngIf="data.febDescriptionBesoin">
    <div class="text-label">Description du besoin</div>
    <p class="text-value">{{ data.febDescriptionBesoin }}</p>
  </div>

  <!-- ───────── SECTION 3 : ACTIVITÉS ───────── -->
  <div class="section-title">
    <mat-icon>bar_chart</mat-icon>
    Activités
  </div>

  <div class="activity" *ngIf="data.febActivites && data.febActivites.length > 0; else noActivites">
    <table class="activites-table">
      <thead>
        <tr>
          <th>Activité</th>
          <th class="pct-col">Répartition</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let a of data.febActivites">
          <td>{{ a.label }}</td>
          <td class="pct-col">{{ a.pourcentage }} %</td>
        </tr>
        <tr class="total-row"
            [class.total-ok]="activitesTotal === 100"
            [class.total-error]="activitesTotal !== 100">
          <td><strong>Total</strong></td>
          <td class="pct-col"><strong>{{ activitesTotal }} %</strong></td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #noActivites>
    <p class="empty-hint">Aucune activité renseignée.</p>
  </ng-template>

  <!-- ───────── SECTION 4 : COMPÉTENCES ───────── -->
  <div class="section-title">
    <mat-icon>school</mat-icon>
    Compétences requises
  </div>

  

  <div class="text-block" *ngIf="data.febNbAnneesExperiences">
    <div class="text-label">Années d'expérience</div>
    <p class="text-value">{{ data.febNbAnneesExperiences }}</p>
  </div>

  <div class="text-block" *ngIf="data.febCompetencesFonctionnelles">
    <div class="text-label">Compétences fonctionnelles</div>
    <p class="text-value">{{ data.febCompetencesFonctionnelles }}</p>
  </div>

  <div class="text-block" *ngIf="data.febCompetencesTechniques">
    <div class="text-label">Compétences techniques</div>
    <p class="text-value">{{ data.febCompetencesTechniques }}</p>
  </div>

  <div class="text-block" *ngIf="data.febEnvironnementTechnique">
    <div class="text-label">Environnement technique</div>
    <p class="text-value">{{ data.febEnvironnementTechnique }}</p>
  </div>

  <div class="text-block" *ngIf="data.febSavoirEtreQualites">
    <div class="text-label">Savoir-être et qualités</div>
    <p class="text-value">{{ data.febSavoirEtreQualites }}</p>
  </div>

  <!-- ───────── FOOTER MÉTADONNÉES ───────── -->
  <div class="meta-footer">
    <span *ngIf="data.createdAt">
      <mat-icon>schedule</mat-icon>
      Créée le {{ data.createdAt | date:'dd/MM/yyyy HH:mm' }}
    </span>
    <span *ngIf="data.updatedAt">
      <mat-icon>update</mat-icon>
      Mise à jour le {{ data.updatedAt | date:'dd/MM/yyyy HH:mm' }}
    </span>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="openHistory()">
    <mat-icon>history</mat-icon> Historique
  </button>
  <button mat-stroked-button (click)="close()">Fermer</button>
</mat-dialog-actions>